import { useQueryClient as p, useMutation as d, useQuery as h } from "react-query";
import { useEnvironment as c } from "../../../common/hooks/environment/useEnvironment.js";
import { getAdapter as r } from "../../adapter.js";
import { ShopSessionAdapter as i } from "../../models/shop/session/shopSession.adapter.js";
function S(e, s = !1) {
  const {
    backendBaseUrl: t
  } = c();
  return h(
    ["shop-session", { forceDb: s }],
    async () => {
      if (e.length === 0)
        return;
      const o = `${t}/shop-service/session/${e}/${s ? "?force_db=true" : ""}`, n = await (await fetch(o, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })).json();
      if (!(n === void 0 || Object.keys(n).length === 0))
        return r(i).adapt(n);
    },
    {
      refetchOnWindowFocus: !1
    }
  );
}
function v() {
  const e = p(), {
    backendBaseUrl: s
  } = c();
  return d(async (t) => {
    const {
      session: o
    } = t, a = r(i).serialize(o), u = await (await fetch(`${s}/shop-service/session/${o.id}/`, {
      method: "PUT",
      body: JSON.stringify(a)
    })).json();
    return r(i).adapt(u);
  }, {
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: ["shop-session"]
      });
    }
  });
}
export {
  v as usePutShopSession,
  S as useShopSession
};
//# sourceMappingURL=useShopSession.js.map
